import { Box, Container, type ContainerProps, VStack } from "@chakra-ui/react"
import type { ReactNode } from "react"

type WmsPageShellProps = {
  children: ReactNode
  maxW?: ContainerProps["maxW"]
}

type WmsPagePanelProps = {
  children: ReactNode
  bg: string
  borderColor: string
}

export function WmsPageShell({ children, maxW = "9xl" }: WmsPageShellProps) {
  return (
    <Container
      maxW={maxW}
      py={{ base: 4, lg: 3 }}
      h={{ base: "auto", lg: "full" }}
      minH={{ base: "auto", lg: 0 }}
      display={{ base: "block", lg: "flex" }}
      flexDirection={{ base: "column", lg: "column" }}
      overflow={{ base: "visible", lg: "hidden" }}
    >
      <VStack
        spacing={4}
        align="stretch"
        h={{ base: "auto", lg: "full" }}
        minH={{ base: "auto", lg: 0 }}
        flex="1"
      >
        {children}
      </VStack>
    </Container>
  )
}

export function WmsPagePanel({ children, bg, borderColor }: WmsPagePanelProps) {
  return (
    <Box
      bg={bg}
      borderWidth="1px"
      borderColor={borderColor}
      borderRadius="2xl"
      p={{ base: 3, md: 4 }}
      boxShadow="sm"
      display="flex"
      flexDirection="column"
      flex="1"
      minH={0}
      overflow="hidden"
    >
      {children}
    </Box>
  )
}
